import { render, staticRenderFns } from "./OperateData.vue?vue&type=template&id=56038bff&scoped=true"
import script from "./OperateData.vue?vue&type=script&lang=js"
export * from "./OperateData.vue?vue&type=script&lang=js"
import style0 from "./OperateData.vue?vue&type=style&index=0&id=56038bff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56038bff",
  null
  
)

export default component.exports